import { ActionType } from "react-table";
import { TableColumn } from "../../../../../Component/Model/Table/Table";
import { ActionsCell } from "../../../../../Component/Common/Components/DataTable/ActionsCell";
import { DefaultCell } from "../../../../../Component/Common/Components/DataTable/DefaultCell";
import { SETAPaymentInformationDto } from "../../../../../Component/Model/Dto/WSP/MerSETALAI";
import { DateFormatter } from "../../../../../Component/Model/helpers";
import { CurrencyFormatter } from "../../../../../Helpers/CurrencyFormatter";

interface PaymentInformationRows {
    paymentDate: string;
    cost: string;
    actions: ActionType[];
}

interface PaymentInformationTable {
    columns: Array<TableColumn>;
    rows: Array<PaymentInformationRows>;
}

export function merSETAPaymentInformationTableMapper(dataObject: SETAPaymentInformationDto[], deletePaymentInformation: (index: number) => void): PaymentInformationTable {
    const columns = [
        { Header: 'Payment Date', accessor: 'paymentDate', id: 'paymentDate', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'Cost', accessor: 'cost', id: 'cost', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true, rightAlign: true },
        { Header: 'Actions', accessor: 'actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true },
    ];
    if(dataObject !== undefined && dataObject.length > 0) {
        const rows = dataObject.map((item: SETAPaymentInformationDto, index: number) => ({
            paymentDate: DateFormatter(item.paymentDate.toString()),
            cost: CurrencyFormatter(item.cost),
            actions: [
                {
                    type: 'Delete',
                    key: index.toString(),
                    label: 'Delete',
                    action: () => {
                        deletePaymentInformation(index);
                    },
                    icon: {
                        color: 'error',
                        name: 'delete'
                    }
                }
            ]
        }));
        return { columns: columns, rows: rows};
    }
    else {
        return { columns: columns, rows: []};
    }
}